import ModelFactory from 'business/models/ModelFactory';
import {
  ExperimentClient,
  ExperimentDTO,
  ExperimentInfo,
  ISOWellDropScoreDTO,
  LayerDTO,
  PlateClient,
  SaveNonPersistedExpDTO,
  SaveScreenExpTemplateDTO,
  ScreenExperimentTemplateDTO,
  ScreenExpWizardClient,
  TreeClient,
} from 'business/models/Models';
import { isNullOrUndefined, getUserToken, getNavigateFunction } from 'utils/Global';
import BaseService from 'business/services/BaseService';
import { NavigateFunction } from 'react-router';

export default class WizardService extends BaseService {
  private get navigate(): NavigateFunction | ((path: string) => void) {
    return getNavigateFunction() ?? function (path: string) {};
  }

  async getWizardScreens(id, plateTypeId = 3) {
    const service: TreeClient = ModelFactory(TreeClient);
    if (id == null) {
      id = -1;
    }
    const userToken = await getUserToken();
    if (isNullOrUndefined(userToken)) {
      this.navigate('/login');
      return null;
    }
    const root = await service.getWizardScreensByParentId(id, plateTypeId);

    return root;
  }

  async getWizardProteins(
    id,
    plateTypeId,
    includePath = false,
    filterByAccessRights = false,
  ) {
    if (id == null) {
      id = -1;
    }
    const userToken = await getUserToken();
    if (isNullOrUndefined(userToken)) {
      this.navigate('/login');
      return null;
    }
    const service: TreeClient = ModelFactory(TreeClient, false, true);

    const root = await service.getWizardProteinsByParentId(
      id,
      plateTypeId,
      includePath,
      filterByAccessRights,
    );

    return root;
  }

  async getWizardFragments(id = -1) {
    const service: TreeClient = ModelFactory(TreeClient, false, true);
    const root = await service.getWizardFragmentsByParentId(id);
    return root;
  }

  async getPlateTypes() {
    const plate: PlateClient = ModelFactory(PlateClient, false, true);
    const platetypes = await plate.getPlateTypesForWizard();
    return platetypes;
  }

  async getExpWizardTemplate(templatename: string) {
    const expWizTemplate: ScreenExpWizardClient = ModelFactory(ScreenExpWizardClient);
    return await expWizTemplate.getScreenExperimentTemplateData(templatename);
  }
  async getTemplateNames() {
    const expWizTemplate: ScreenExpWizardClient = ModelFactory(ScreenExpWizardClient);
    return await expWizTemplate.getScreenExperimentTemplateNames();
  }

  async saveScreenExpTemplateByFileName(
    fileName,
    screenExpTemplateData: ScreenExperimentTemplateDTO,
  ) {
    ///make these apis authentication
    const expWizTemplate: ScreenExpWizardClient = ModelFactory(ScreenExpWizardClient);
    const saveScreenExpTemplate = new SaveScreenExpTemplateDTO();
    saveScreenExpTemplate.screenExperimentTemplate = screenExpTemplateData;
    saveScreenExpTemplate.fileName = fileName;
    return await expWizTemplate.saveScreenExperimentTemplateData(saveScreenExpTemplate);
  }

  async createExperiment(expInfo: ExperimentInfo, treeNodeId: number) {
    const expWizTemplate: ScreenExpWizardClient = ModelFactory(ScreenExpWizardClient);
    const expDTO = new SaveNonPersistedExpDTO();
    expDTO.experimentInfo = expInfo;
    expDTO.paretnTreeNodeId = treeNodeId;
    return await expWizTemplate.createExperiment(expDTO);
  }

  async saveWizardExperiment(
    expDto: ExperimentDTO,
    expInfo: ExperimentInfo,
    treeNodeid,
    layers?: LayerDTO[],
    isoScores?: ISOWellDropScoreDTO[],
    plateTypeId?: number,
    existingExperimentId?: number,
  ) {
    const expWizTemplate: ExperimentClient = ModelFactory(ExperimentClient);
    const saveWizardExp = new SaveNonPersistedExpDTO();
    saveWizardExp.paretnTreeNodeId = treeNodeid;
    saveWizardExp.experimentInfo = expInfo;
    saveWizardExp.expDto = expDto;
    saveWizardExp.layers = layers;
    saveWizardExp.isoScores = isoScores;
    saveWizardExp.plateTypeId = plateTypeId;
    saveWizardExp.existingExperimentId = existingExperimentId;
    return await expWizTemplate.saveWizardExperiment(saveWizardExp);
  }
}
